import { render } from "./MainEvent.vue?vue&type=template&id=07fcfbc1&scoped=true"
import script from "./MainEvent.vue?vue&type=script&lang=js"
export * from "./MainEvent.vue?vue&type=script&lang=js"

import "./MainEvent.vue?vue&type=style&index=0&id=07fcfbc1&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fcfbc1"]])

export default __exports__